var ReplaceSimple = {
    init: function () {
        $('[data-replace-simple]:checkbox').each(function (k, element) {
            ReplaceSimple.bind($(element));
        });
    },
    bind: function ($element) {
        var $targets = $($element.attr('data-replace-simple')),
            valid = $element.attr('data-replace-simple-valid'),
            invalid = $element.attr('data-replace-simple-invalid'),
            text = $element.attr('data-replace-simple-text');

        var cb = function () {
            var checked = $element.is(':checked');

            $targets.each(function (k, target) {
                var initialized = target.ReplaceInitialized || false;
                var $target = $(target);

                if (!initialized) {
                    target.ReplaceOriginal = $target.html();
                    target.ReplaceInitialized = true;
                }

                $target.html(target.ReplaceOriginal.replace(new RegExp(text, 'g'), checked ? valid : invalid));
            });
        };

        $element.on('change', cb);
        cb();
    }
};

$(document).ready(function () {
    ReplaceSimple.init();
});
